module.exports = __webpack_public_path__ + "static/media/underlne.03a12972.ico";